import { AfterViewInit, Directive, ElementRef, HostBinding } from "@angular/core";

@Directive({
  selector: 'ag-grid-angular'
})
export class AgGridThemeDirective implements AfterViewInit {

  public get prefersDark() {
    return window.document.documentElement.classList.contains('root-dark-theme');
  }

  @HostBinding('class.ag-theme-alpine-dark')
  get darkMode() {
    return this.prefersDark;
  }

  @HostBinding('class.ag-theme-alpine')
  get lightMode(): boolean {
    return !this.darkMode;
  }

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {}

}
